(() => {
  const initFooter = (footer) => {
    if (!footer || footer.dataset.oeFooterReady === 'true') return;
    footer.dataset.oeFooterReady = 'true';

    footer.querySelectorAll('[data-oe-chat-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', async () => {
        if (window.customElements?.whenDefined) {
          await Promise.race([
            window.customElements.whenDefined('shopify-chat'),
            new Promise((resolve) => window.setTimeout(resolve, 1200)),
          ]);
        }

        const chat = document.querySelector('shopify-chat');
        if (chat && typeof chat.show === 'function') {
          chat.show();
          return;
        }

        trigger.setAttribute('aria-disabled', 'true');
        const detail = trigger.querySelector('[data-oe-chat-detail]');
        if (detail) detail.textContent = 'Chat unten rechts öffnen';
      });
    });

    const columns = footer.querySelectorAll('[data-oe-footer-column]');
    const desktop = window.matchMedia('(min-width: 768px)');
    const syncColumns = () => {
      columns.forEach((column) => {
        if (desktop.matches) column.open = true;
        else if (!column.dataset.oeMobileInitialized) {
          column.open = false;
          column.dataset.oeMobileInitialized = 'true';
        }
      });
    };

    syncColumns();
    desktop.addEventListener?.('change', syncColumns);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-oe-footer]').forEach(initFooter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
